import {Highlight, connectRefinementList} from "react-instantsearch-dom";
import {orderBy, sortBy, chain, indexOf} from "lodash";
import CheckBoxRefinementList from "./CheckBoxRefinementList";
import {useTranslation} from "react-i18next";

const SQFeetRefinementList = () => {

    const {t, i18n} = useTranslation();

    const initialLabel = () => {
        if (window.win_language_code == 'en-ca') {
            return 'Square Meters';
        }
        return t('Square.Footage');
    }

    const initialSearchAttribute = () => {
        if (window.win_language_code == 'en-ca' || window.win_language_code == 'fr-ca') {
            return 'square_meter_range';
        }

        return 'square_footage_range';
    }

    const initialSortSQSort = () => {
        if (window.win_language_code == 'en-ca' || window.win_language_code == 'fr-ca') {
            return [
                '< 3,000',
                '3,000 - 15,000',
                '15,000 - 65,000',
                '65,000 +'
            ];
        }

        return [
            '< 10,000',
            '10,000 - 50,000',
            '50,000 - 200,000',
            '200,000 +'
        ];

    }


    return (
        <React.Fragment>
            <label className="form__label" htmlFor="material-exp">{initialLabel()}</label>
            <CheckBoxRefinementList operator="or" attribute={initialSearchAttribute()}
                                    initialFacets={window.all_square_footage} initialSort={initialSortSQSort()}/>
        </React.Fragment>
    );
}

export default SQFeetRefinementList;
